// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap */
import { Record } from "immutable"

type InputType = {
  name: string
  code: string
  price: number
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line babel/camelcase
  booking_url: string | null | undefined
  source: string
}

const JourneyProviderRecord = Record({
  name: "",
  code: null,
  price: null,
  bookingUrl: null,
  source: null,
})

export default class JourneyProvider extends JourneyProviderRecord {
  static fromPlainJS(input: InputType) {
    return new JourneyProvider({
      name: input.name,
      code: input.code,
      // @ts-expect-error: Flow to TS migration.
      price: parseFloat(input.price),
      bookingUrl: input.booking_url,
      source: input.source,
    })
  }
}
